//#region frontend/islands/reviews-slider.js
var STAR_PATH = "M11.4127 0L13.5287 9.08754L22.8254 8.2918L14.8365 13.1125L18.4661 21.7082L11.4127 15.6L4.35927 21.7082L7.98889 13.1125L1.14441e-05 8.2918L9.29666 9.08754L11.4127 0Z";
function renderStars(rating) {
	const full = Math.floor(rating);
	const half = rating % 1 > 0;
	const svg = (clip = false) => `<svg width="23" height="22" viewBox="0 0 23 22"${clip ? " style=\"clip-path:inset(0 50% 0 0)\"" : ""} aria-hidden="true" focusable="false"><path fill="currentColor" d="${STAR_PATH}"/></svg>`;
	return svg().repeat(full) + (half ? svg(true) : "");
}
var ReviewsSlider = class extends HTMLElement {
	async connectedCallback() {
		this.swiperEl = this.querySelector("swiper-container");
		if (!this.swiperEl) return;
		const { stampedApiKey: apiKey, stampedStoreId: storeId } = this.dataset;
		if (apiKey && storeId) await this.loadStampedReviews(apiKey, storeId);
		this._equalize = this.equalizeSlideHeights.bind(this);
		this._onResize = () => {
			clearTimeout(this._resizeTimer);
			this._resizeTimer = setTimeout(this._equalize, 150);
		};
		this.swiperEl.addEventListener("init", this._equalize, { once: true });
		requestAnimationFrame(() => {
			if (this.swiperEl.swiper?.initialized) this._equalize();
		});
		window.addEventListener("resize", this._onResize);
	}
	async loadStampedReviews(apiKey, storeId) {
		const slides = [...this.swiperEl.querySelectorAll("swiper-slide[data-review-id]")];
		if (!slides.length) return;
		const reviews = await Promise.all(slides.map((slide) => this.fetchReview(apiKey, storeId, slide.dataset.reviewId)));
		slides.forEach((slide, i) => {
			if (reviews[i]) this.populateSlide(slide, reviews[i]);
		});
	}
	async fetchReview(apiKey, storeId, reviewId) {
		if (!reviewId) return null;
		try {
			const url = new URL("https://stamped.io/api/widget/reviews");
			url.searchParams.set("apiKey", apiKey);
			url.searchParams.set("storeUrl", storeId);
			url.searchParams.set("take", "1");
			url.searchParams.set("reviewId", reviewId);
			const res = await fetch(url);
			if (!res.ok) return null;
			return (await res.json())?.data?.[0] ?? null;
		} catch {
			return null;
		}
	}
	populateSlide(slide, review) {
		const rating = review.reviewRating ?? 5;
		const starsEl = slide.querySelector("[data-stars]");
		if (starsEl) {
			starsEl.setAttribute("aria-label", `Rated ${rating} out of 5 stars`);
			starsEl.innerHTML = `<span class="stars text-gold">${renderStars(rating)}</span>`;
		}
		const taglineEl = slide.querySelector("[data-tagline]");
		if (taglineEl) taglineEl.textContent = review.reviewTitle ?? "";
		const bodyEl = slide.querySelector("[data-body]");
		if (bodyEl) bodyEl.textContent = review.reviewMessage ?? "";
		const attributionEl = slide.querySelector("[data-attribution]");
		if (attributionEl) attributionEl.textContent = [review.author, review.productName].filter(Boolean).join(" — ");
	}
	equalizeSlideHeights() {
		const slides = this.swiperEl.querySelectorAll("swiper-slide");
		let maxHeight = 0;
		this.swiperEl.style.height = "";
		slides.forEach((slide) => {
			slide.style.height = "auto";
		});
		slides.forEach((slide) => {
			maxHeight = Math.max(maxHeight, slide.offsetHeight);
		});
		slides.forEach((slide) => {
			slide.style.height = "";
		});
		if (maxHeight > 0) this.swiperEl.style.height = maxHeight + "px";
	}
	disconnectedCallback() {
		clearTimeout(this._resizeTimer);
		window.removeEventListener("resize", this._onResize);
	}
};
customElements.define("reviews-slider", ReviewsSlider);
//#endregion
